'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Slider/Slider.tsx
import * as SliderPrimitive from "@radix-ui/react-slider";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var RANGE_THEME_CLASSES = {
  primary: "bg-primary",
  secondary: "bg-secondary",
  tertiary: "bg-tertiary",
  action: "bg-action",
  error: "bg-error",
  success: "bg-success",
  white: "bg-dark",
  black: "bg-light",
  transparent: "bg-transparent"
};
var THUMB_THEME_CLASSES = {
  primary: "border-primary focus:ring-primary",
  secondary: "border-secondary focus:ring-secondary",
  tertiary: "border-tertiary focus:ring-tertiary",
  action: "border-action focus:ring-action",
  error: "border-error focus:ring-error",
  success: "border-success focus:ring-success",
  white: "border-dark focus:ring-dark",
  black: "border-light focus:ring-light",
  transparent: "border-transparent focus:ring-transparent"
};
var Slider = (_a) => {
  var _b = _a, { className, theme = "primary" } = _b, props = __objRest(_b, ["className", "theme"]);
  const value = props.value || props.defaultValue;
  return /* @__PURE__ */ jsxs(
    SliderPrimitive.Root,
    __spreadProps(__spreadValues({
      className: twMerge("relative flex w-full touch-none select-none items-center", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx(SliderPrimitive.Track, { className: "bg-body-level-1 relative h-[3px] w-full grow overflow-hidden rounded-full", children: /* @__PURE__ */ jsx(SliderPrimitive.Range, { className: twMerge("absolute h-full", RANGE_THEME_CLASSES[theme]) }) }),
        value == null ? void 0 : value.map((_, i) => /* @__PURE__ */ jsx(
          SliderPrimitive.Thumb,
          {
            className: twMerge(
              "bg-body ring-offset-body block h-5 w-5 rounded-[4px] border-2 focus:ring-1 focus:ring-offset-1 disabled:pointer-events-none",
              THUMB_THEME_CLASSES[theme]
            )
          },
          i
        ))
      ]
    })
  );
};
var Slider_default = Slider;

export {
  Slider_default
};
//# sourceMappingURL=chunk-5MNY5DB4.mjs.map